import { createRootRoute, createRoute, createRouter } from '@tanstack/react-router';
import { BusTimesPage } from '@/features/schedules/BusTimesPage';
import { NotFoundPage } from '@/components/NotFoundPage';
import { SURFACES } from '@/lib/gql/__generated__/surfaces';
import { guardSurface } from '@/lib/platform/surfaces';
import type { AppEntry } from '@/app/routes-types';

export const entry: AppEntry = { default: '/', byRole: {} };

const rootRoute = createRootRoute({ notFoundComponent: NotFoundPage });
const busTimesRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/',
  beforeLoad: () => guardSurface(entry, SURFACES['bus-times']),
  staticData: { title: 'Seattle Bus Times', page: SURFACES['bus-times'], standalone: false, isPublic: true },
  component: BusTimesPage,
});
const routeTree = rootRoute.addChildren([busTimesRoute]);
export const router = createRouter({ routeTree });

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}
